// components/sections/PaymentHistoryTableSection.tsx

import { Banknote } from 'lucide-react';

interface PaymentItem {
  paymentId: number;
  paymentDate: string;
  totalPaid: number;
  notes?: string;
}

interface Props {
  payments: PaymentItem[];
}

const PaymentHistoryTableSection = ({
  payments,
}: Props) => {
  return (
    <section className="p-6">
      {/* Header */}
      <div className="mb-5">
        <h3 className="font-semibold text-black dark:text-white">
          Movimientos Registrados
        </h3>

        <p className="mt-1 text-sm text-body dark:text-bodydark">
          Historial completo de pagos aplicados a esta cuenta
        </p>
      </div>

      {/* Tabla */}
      <div
        className="
          overflow-x-auto
          rounded-xl
          border border-stroke
          dark:border-strokedark
        "
      >
        <table className="w-full">
          <thead>
            <tr
              className="
                border-b border-stroke
                bg-gray-2
                dark:border-strokedark
                dark:bg-boxdark-2
              "
            >
              <th
                className="
                  px-6 py-4
                  text-left text-sm font-semibold
                  text-body
                "
              >
                Cobro
              </th>

              <th
                className="
                  px-6 py-4
                  text-left text-sm font-semibold
                  text-body
                "
              >
                Monto Pagado
              </th>

              <th
                className="
                  px-6 py-4
                  text-left text-sm font-semibold
                  text-body
                "
              >
                Observaciones
              </th>
            </tr>
          </thead>

          <tbody>
            {payments.length > 0 ? (
              payments.map((payment) => (
                <tr
                  key={payment.paymentId}
                  className="
                    border-b border-stroke
                    transition-colors
                    last:border-0
                    hover:bg-gray-2/60
                    dark:border-strokedark
                    dark:hover:bg-boxdark-2
                  "
                >
                  {/* Fecha */}
                  <td className="px-6 py-5">
                    <div className="flex items-center gap-3">
                      <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-success/10 text-success">
                        <Banknote className="h-4 w-4" />
                      </span>
                      <p className="font-medium text-black dark:text-white">
                        {payment.paymentDate}
                      </p>
                    </div>
                  </td>

                  {/* Monto */}
                  <td className="px-6 py-5">
                    <span
                      className="
                        inline-flex
                        rounded-full
                        border border-success/20
                        bg-success/10
                        px-3 py-1
                        text-sm font-semibold
                        text-success
                      "
                    >
                      ${Number(payment.totalPaid || 0).toFixed(2)}
                    </span>
                  </td>

                  {/* Observaciones */}
                  <td className="px-6 py-5">
                    <p className="text-sm text-black dark:text-white">
                      {payment.notes || "Sin observaciones"}
                    </p>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={3}
                  className="
                    px-6 py-10
                    text-center
                  "
                >
                  <div className="space-y-2">
                    <p className="font-medium text-black dark:text-white">
                      No hay pagos registrados
                    </p>

                    <p className="text-sm text-body dark:text-bodydark">
                      Esta cuenta aún no posee movimientos de pago
                    </p>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default PaymentHistoryTableSection;